import { useEffect, useState } from 'react';
import { CloudOff, RefreshCw } from 'lucide-react';
import { usePendingSyncCount } from '@/lib/sync/useSync';
import { isSupabaseConfigured } from '@/lib/supabase';

/**
 * Dos estados distintos que la gente confunde: "no hay red" y "hay cosas sin
 * subir". Se muestran por separado porque la accion del usuario es distinta.
 */
export function ConnectionStatus() {
  const [online, setOnline] = useState(() => navigator.onLine);
  const pending = usePendingSyncCount();

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  // Sin nube configurada no hay nada que subir: enseñar "3 cambios pendientes"
  // para siempre sería mentir. La cola se guarda igual, por si se configura
  // Supabase más adelante.
  const showPending = isSupabaseConfigured && pending > 0;
  if (online && !showPending) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="connection-status"
      className="flex items-center justify-center gap-2 bg-[var(--color-surface-2)] px-3 py-1.5 text-xs text-[var(--color-text-muted)]"
    >
      {!online ? (
        <>
          <CloudOff aria-hidden="true" className="size-4" />
          <span>
            {isSupabaseConfigured
              ? 'Sin conexión. Se guarda en el móvil y se sube al volver.'
              : 'Sin conexión. Todo sigue funcionando.'}
          </span>
        </>
      ) : (
        <>
          <RefreshCw aria-hidden="true" className="size-4 animate-spin" />
          <span>
            Subiendo {pending} {pending === 1 ? 'cambio' : 'cambios'}…
          </span>
        </>
      )}
    </div>
  );
}
